import { IMappingDetails } from '../products/Products.interface';
import { FormControl } from '@angular/forms';

/* Begin::Retailer Reward */
export interface IReward {
  product_name: string;
  point_total: number;
  generate_date: string;
}

export const dummyDataRewardRequest: IReward[] = [
  {
    product_name: 'MAXXFOSFATE EVO 525SL - 250ml',
    point_total: 300,
    generate_date: '08-01-2023 07:00:00',
  },
];

export interface IDataDescriptionMapping extends Array<IMappingDetails> {}

export interface IDataHistoryQrTable extends Array<IReward> {}

export interface IKeyValue {
  key: string;
  value: string | number;
}

export interface IDataRewardDesc {
  created_date: string;
  created_by: string;
  point: number;
  grade: string;
}
/* End::Retailer Reward */

export interface IFormRegisterMAC {
  retailer_id: FormControl<string>;
  sub_district_id: FormControl<string[]>;
  npwp: FormControl<string>;
  npwp_image_url: FormControl<string>;
}
export interface IPayloadRegisterMAC {
  retailer_id: string;
  sub_district_id: string[];
  npwp: string;
  npwp_image_url: string;
}

export interface IMitraListMAC {
  name: string;
  retailer: string[];
}

export interface IDataRetailerList {
  status: string;
  tab?: string;
  view?: string;
}

export interface IDataInputQR {
  qr_code: string
  longitude?: string
  latitude?: string
}

export interface IQRScan {
  value : number;
  target: string;
}

export interface IProgress {
  completion : string;
  string_level: string;
  completed_times: string;
}

export interface IProgramMarketingList {
  id: string;
  program_name: string;
  is_multilevel_target: boolean;
  qr_scan_quantity: IQRScan;
  string_level: string;
  progress: IProgress;
  status_enum: string;
  status_string: string;
}

export interface IDownloadCsv {
  retailerCode : string;
  retailerName : string;
  salesName : string;
  productScanned : string;
  couponCode : string;
  programName : string;
  soCodeOrigin : string;
  distributorOrigin : string;
  unitAmount : number;
  qtyBox : number;
  qtyInPack : number;
  qtyMediumPack : number;
  soAccumulation : number;
  description : string;
  valueLabel : string;
  value : number;
}
